export enum SIGNUP_AGREEMENT_TYPE {
  BROADCASTING_AGREEMENT = "broadcasting_agreement",
  BROADCAST_RELEASE = "broadcast_release",
  PERFORMANCE_AGREEMENT = "performers_agreement",
}
